// extracted by mini-css-extract-plugin
export default {"dropDownSelect":"DropDownLanguage_dropDownSelect__Ceqom","footerDropDown":"DropDownLanguage_footerDropDown__kCyqJ"};